import cn from 'classnames';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import Image from 'next/image';

import MeshBackground from 'react-scale/components/ui/webgl';
import CTA from 'react-scale/components/ui/cta';

import PropTypes from 'prop-types';

import styles from '../../ui/text/text.module.css';

const HeroDefaultLeft = ({ icon, overtitle, title, product, subtitle, cta, bgAnimated }) => (
  <div className="text-white bg-black">
    {bgAnimated && <MeshBackground />}
    <div className="relative">
      <div className="container w-full py-10 lg:py-32">
        {icon && (
          <div className="relative w-16 h-16 mb-4">
            <Image src={icon.src} alt={icon.alt} width={icon.width} height={icon.height} />
          </div>
        )}
        <h4 className="inline-block mb-4 text-overtitle-sm text-gradient">{overtitle}</h4>
        <h1
          className={cn('font-aeonik', product ? 'text-5xl md:text-7xl' : 'text-4xl md:text-5xl')}
        >
          {title} <span className="text-gradient">{product}</span>
        </h1>
        <ReactMarkdown
          rehypePlugins={[rehypeRaw]}
          className={cn(styles.text, 'mt-6 text-base lg:text-lg')}
        >
          {subtitle}
        </ReactMarkdown>
        <div className="mt-12 mb-12 lg:w-3/4 lg:mb-0">
          <CTA cta={cta} />
        </div>
      </div>
    </div>
  </div>
);

HeroDefaultLeft.propTypes = {
  bgAnimated: PropTypes.bool
};

HeroDefaultLeft.defaultProps = {
  bgAnimated: true
};

export default HeroDefaultLeft;
